import React from 'react';
import DataTable from 'react-data-table-component';
import { MenuComponent } from '../../assets/ts/components';

type Props = {
  data: any;
  columns: [];
  minHeight?: string;
  /** Llena el espacio vertical disponible del contenedor padre (debe tener
   * altura definida, ej. flex-grow-1) y hace scroll interno en las filas,
   * dejando el encabezado fijo y el paginador siempre visible al fondo. */
  fillHeight?: boolean;
};

const TableList: React.FC<Props> = ({ data, columns, minHeight = '0', fillHeight = false }) => {
  const table = (
    <DataTable
        columns={columns}
        data={data}
        expandableRowsHideExpander
        onChangePage={() => {
          MenuComponent.reinitialization();
        }}
        pagination
        responsive
        fixedHeader={fillHeight}
        fixedHeaderScrollHeight={fillHeight ? '100%' : undefined}
        customStyles={{
          table: {
            style: {
              minHeight: minHeight,
              height: fillHeight ? '100%' : undefined,
              backgroundColor: 'var(--tc-bg-surface)',
            },
          },
          tableWrapper: {
            style: {
              backgroundColor: 'var(--tc-bg-surface)',
              border: '1px solid var(--tc-border)',
              borderRadius: '8px',
              overflow: 'hidden',
              ...(fillHeight ? { height: '100%' } : {}),
            },
          },
          rows: {
            style: {
              borderBottom: '1px dashed var(--tc-border)',
              paddingTop: '5px',
              paddingBottom: '5px',
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text)',
            },
            highlightOnHoverStyle: {
              backgroundColor: 'var(--tc-bg-raised)',
              color: 'var(--tc-text)',
            },
          },
          headRow: {
            style: {
              borderBottom: '1px dashed var(--tc-border)',
              backgroundColor: 'var(--tc-bg-raised)',
            },
          },
          headCells: {
            style: {
              color: 'var(--tc-text-muted)',
              fontSize: '12.5px',
            },
          },
          cells: {
            style: {
              color: 'var(--tc-text)',
              fontSize: '13px',
            },
          },
          pagination: {
            style: {
              borderTopStyle: 'none',
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text)',
              fontSize: '13px',
              minHeight: '44px',
            },
            pageButtonsStyle: {
              color: 'var(--tc-text)',
              fill: 'var(--tc-text)',
              height: '32px',
              width: '32px',
              padding: '4px',
            },
          },
          noData: {
            style: {
              backgroundColor: 'var(--tc-bg-surface)',
              color: 'var(--tc-text-muted)',
            },
          },
        }}
        paginationComponentOptions={{
          rowsPerPageText: 'Registros por página',
          rangeSeparatorText: 'de',
        }}
        noDataComponent={
          <>
            <div className="d-flex align-items-center">
              <div className="text-muted text-center fs-6 w-100 m-5">
                Sin registros
              </div>
            </div>
          </>
        }
        persistTableHead
      ></DataTable>
  );

  if (!fillHeight) return table;

  return (
    <div className="d-flex flex-column flex-grow-1" style={{ minHeight: 0, height: '100%' }}>
      {table}
    </div>
  );
};

export { TableList };
